export class BeException extends Error {

  // Make sure this is hard-coded as a string
  // BeException.name will not work in production
  // because class names are changed when minified
  className: string = 'BeException';
  code: number | undefined;
  prev: Error | undefined;

  constructor(message?: string, code?: number, prev?: any) {
    super(message);
    if ((Error as any).captureStackTrace !== undefined) {
      (Error as any).captureStackTrace(this, this.constructor);
    };
    this.name = this.constructor.name;
    this.code = code;
    this.prev = prev;
  }
}

export class AuthException extends BeException {

  className: string = 'AuthException';
  lockedUntil: number | undefined;

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Access denied', code, prev);
  }
}

export class AuthLockedException extends AuthException {

  className: string = 'AuthLockedException';

  constructor(message?: string, code?: number, lockedUntil?: number) {
    super(message, code);
    this.lockedUntil = lockedUntil || undefined;
  }
}

export class AccessDeniedException extends BeException {

  className: string = 'AccessDeniedException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Access denied', code, prev);
  }
}

export class NotFoundException extends BeException {

  className: string = 'NotFoundException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Resource not found', code, prev);
  }
}

export class BadRequestException extends BeException {

  className: string = 'BadRequestException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Bad request', code, prev);
  }
}

export class ValidationException extends BadRequestException {

  className: string = 'ValidationException';

  fields: any;

  constructor(message?: string, fields?: any) {
    super(message);
    this.fields = fields;
  }
}

export class UnprocessableEntityException extends BeException {

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Unprocessable entity', code, prev);
  }
}

export class ServerErrorException extends BeException {

  className: string = 'ServerErrorException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Internal server error', code, prev);
  }
}

export class LocalException extends Error {

  className: string = 'LocalException';
  code: number | undefined;
  prev: Error | undefined;

  constructor(message?: string, code?: number, prev?: any) {
    super(message);
    if ((Error as any).captureStackTrace !== undefined) {
      (Error as any).captureStackTrace(this, this.constructor);
    };
    this.name = this.constructor.name;
    this.code = code;
    this.prev = prev;
  }
}

export class NetworkErrorException extends LocalException {

  className: string = 'NetworkErrorException';

  constructor(message?: string, code?: number, prev?: any) {
    super(message || 'Network error', code, prev);
  }
}

export const ORDER_SIGNER_SQUEEZE_ID_ALREADY_EXISTS = 1413;